// Helper function to ensure localhost has port 3000
const getEnsureLocalhostPort = (baseUrl: string) => {
  if (baseUrl && baseUrl.includes("localhost") && !baseUrl.includes(":3000")) {
    // If baseUrl is localhost without a port, add port 3000
    return baseUrl.replace("localhost", "localhost:3000");
  }
  return baseUrl;
};

export default getEnsureLocalhostPort;
